import FileSaver from 'file-saver';

/**
 * exportFile()   use FileSaver.js to implement file download feature
 *
 * FileSaver.js only provides file download without file type conversion.
 * You need to convert the file type on your own if you have the requirements.
 *
 * https://github.com/eligrey/FileSaver.js/
 *
 * @param data  data segments to generate blob
 * @param type  MIME type of generated file, default is '.text'
 * @param fileName  default file name
 */

function exportFile(data, type, fileName) {
  const blob = new Blob([data], { type: type });

  FileSaver.saveAs(blob, fileName);
}

export default exportFile;
